import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Proofofimpact from "./sections/Proofofimpact";
import Expertise from "./sections/Expertise";
import Groeiformule from "./sections/Groeiformule";
import Groei from "./sections/Groei";
import EditorialServiceGallery from "./sections/EditorialServiceGallery";
import CaseStudy from "./sections/CaseStudy";
import TechnicalMetricsGrid from "./sections/TechnicalMetricsGrid";
import Logoticker from "./sections/Logoticker";
import Testimonials from "./sections/Testimonials";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Logoticker />
      <Proofofimpact />
      <Expertise />
      <Groeiformule />
      <Groei />
      <EditorialServiceGallery />
      <CaseStudy />
      <TechnicalMetricsGrid />
      <Testimonials />
      <Contact />
      <Footer />
    </div>;
}